<template>
  <div class="container register bg-gradient-primary">
    <div class="row">
      <div class="col-md-3 register-left">
        <img :src="'images/logo_easycmt.png'" alt="content-moderation-tool" />
        <br />
        <h5>No credit card needed</h5>
        <h5>24/7 support</h5>
        <br />
        <img :src="'images/content-moderation-tool.png'" alt="content-moderation-tool-icon" />
      </div>
      <div class="col-md-9 register-right">
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
            <h3 v-if="!hasBeenSubmitted" class="register-heading">Free 30 days trial</h3>
            <div v-if="hasBeenSubmitted">
              <h2 class="register-heading">Thank You for Your registration!</h2>
              <h4 class="register-message">We will confirm Your account in 3 working days.</h4>
              <h4 class="register-message">
                Check Your email for more details. In case You didn't receive the email please register one more
                <a href="/easy-cmt">time.</a>
              </h4>
            </div>
            <form class="row register-form" v-else @submit.prevent="handleSubmit">
              <div class="col-md-6">
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.form.name.$error }"
                    placeholder="First Name *"
                    v-model="form.name"
                  />
                  <div v-if="$v.form.name.$error" class="invalid-feedback">
                    <span v-if="!$v.form.name.required">First Name is required</span>
                    <span v-if="submitted && !$v.form.name.maxLength">First Name exceeded max symbols (255) </span>
                  </div>
                </div>
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.form.lastname.$error }"
                    placeholder="Last Name *"
                    v-model="form.lastname"
                  />
                  <div v-if="$v.form.lastname.$error" class="invalid-feedback">
                    <span v-if="!$v.form.lastname.required">Last name is required</span>
                    <span v-if="submitted && !$v.form.lastname.maxLength">Last Name exceeded max symbols (255) </span>
                  </div>
                </div>
                <div class="form-group">
                  <vue-tel-input
                    :class="{ 'form-control is-invalid': submitted && !validated }"
                    v-model="form.phone"
                    v-bind="bindProps"
                    @validate="validatePhone"
                  ></vue-tel-input>
                  <div v-if="submitted && !validated" class="invalid-feedback">Invalid telephone number</div>
                </div>
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.form.companyName.$error }"
                    placeholder="Company"
                    v-model="form.companyName"
                  />
                  <div v-if="$v.form.companyName.$error" class="invalid-feedback">
                    <span v-if="submitted && !$v.form.companyName.maxLength">Company exceeded max symbols (255) </span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input
                    type="email"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.form.email.$error }"
                    placeholder="Your Email *"
                    v-model="form.email"
                  />
                  <div v-if="$v.form.email.$error" class="invalid-feedback">
                    <span v-if="!$v.form.email.required">Email is required</span>
                  </div>
                </div>
                <div class="form-group">
                  <input
                    type="password"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.form.password.$error }"
                    placeholder="Password *"
                    v-model="form.password"
                  />
                  <div v-if="$v.form.password.$error" class="invalid-feedback">
                    <span v-if="!$v.form.password.required">Password is required</span>
                    <span v-if="submitted && !$v.form.password.minLength">Password must be at least 6 symbols</span>
                  </div>
                </div>
                <div class="form-group">
                  <input
                    type="password"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.form.confirmPassword.$error }"
                    placeholder="Confirm Password *"
                    v-model="form.confirmPassword"
                  />
                  <div v-if="submitted && $v.form.confirmPassword.$error" class="invalid-feedback">
                    <span v-if="!$v.form.confirmPassword.required">Confirm Password is required</span>
                    <span v-else-if="!$v.form.confirmPassword.sameAsPassword">Passwords must match</span>
                  </div>
                </div>
                <button type="submit" class="btnRegister">Register</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {maxLength, minLength, required, sameAs} from 'vuelidate/lib/validators';
import axios from 'axios';

export default {
  name: 'Registration',
  data() {
    return {
      bindProps: {
        mode: 'international',
        placeholder: 'Phone number',
        autocomplete: 'on',
        name: 'telephone',
        maxLen: 25,
        validCharactersOnly: true,
      },
      form: {
        name: '',
        lastname: '',
        password: '',
        confirmPassword: '',
        email: '',
        phone: '',
        countryName: '',
        companyName: '',
      },
      submitted: false,
      hasBeenSubmitted: false,
      passwordsMatch: false,
      valid: false,
      validated: false,
    };
  },
  validations: {
    form: {
      name: { required, maxLength: maxLength(255) },
      lastname: { required, maxLength: maxLength(255) },
      password: { required, minLength: minLength(6) },
      email: { required, maxLength: maxLength(255) },
      confirmPassword: { required, sameAsPassword: sameAs('password') },
      companyName: { maxLength: maxLength(255) },
    },
  },
  methods: {
    handleSubmit(e) {
      this.submitted = true;
      e.preventDefault();
      this.$v.$touch();
      if (this.$v.$invalid || this.valid === false) {
        return;
      }
      this.validated = true;
      axios
        .post('/ajax/registration/easy-cmt', {
          formData: '' + JSON.stringify(this.form),
        })
        .then((response) => {
          this.submitted = false;
          this.hasBeenSubmitted = true;
        })
        .catch((error) => {
          this.$toaster.error(error.response.data.message);
          this.submitted = false;
        });
    },
    validatePhone: function ({ number, isValid, country }) {
      this.form.countryName = country.name;
      this.valid = isValid;
      this.validated = isValid;
    },
  },
};
</script>

<style scoped>
.bg-gradient-primary {
  background-image: linear-gradient(#ed1a3a, #7f091b 100%) !important;
}
.btnRegister {
  background: #ca1732 !important;
}
.btnRegister:hover {
  background: #7f091b !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Registration.vue